import { initialState } from "./index";
import { createSelector } from "@reduxjs/toolkit";

const selectLeadsOptedInTasState = (state) =>
  state.leadsOptedInTas || initialState;

export const leadsOptedInListSelector = createSelector(
  [selectLeadsOptedInTasState],
  (leadsOptedInTasState) => leadsOptedInTasState.leadsOptedInList
);

export const createLeadsOptedInSelector = createSelector(
  [selectLeadsOptedInTasState],
  (leadsOptedInTasState) => leadsOptedInTasState.createLeadsOptedIn
);

export const reOptInSelector = createSelector(
  [selectLeadsOptedInTasState],
  (leadsOptedInTasState) => leadsOptedInTasState.reOptIn
);

export const updateLeadsOptedInSelector = createSelector(
  [selectLeadsOptedInTasState],
  (state) => state.updateLeadsOptedIn
);

export const deleteLeadsOptedInSelector = createSelector(
  [selectLeadsOptedInTasState],
  (state) => state.deleteLeadsOptedIn
);
